import React, { useState } from 'react';
import { Layout, ConfigProvider, Menu } from 'antd';
import { CameraOutlined, PictureOutlined } from '@ant-design/icons';
import './App.css';
import CameraCapture from "./components/CameraCapture";
import PhotoGallery from "./components/PhotoGallery";

const { Header, Content, Footer, Sider } = Layout;

function App() {
  const [selectedKey, setSelectedKey] = useState('camera');

  const menuItems = [
    {
      key: 'camera',
      icon: <CameraOutlined />,
      label: 'Камера',
    },
    {
      key: 'gallery',
      icon: <PictureOutlined />,
      label: 'Галерея',
    },
  ];

  const renderContent = () => {
    switch (selectedKey) {
      case 'camera':
        return <CameraCapture />;
      case 'gallery':
        return <PhotoGallery />;
      default:
        return <CameraCapture />;
    }
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1890ff',
          borderRadius: 8,
        },
      }}
    >
      <Layout className="app-layout">
        <Header className="app-header">
          <div className="header-content">
            <CameraOutlined className="header-icon" />
            <h1 className="app-title">Фото Камера</h1>
          </div>
        </Header>
        
        <Layout>
          <Sider 
            width={200} 
            className="app-sider"
            breakpoint="lg"
            collapsedWidth="0"
          >
            <Menu
              mode="inline"
              selectedKeys={[selectedKey]}
              items={menuItems}
              onClick={({ key }) => setSelectedKey(key)}
              className="app-menu"
            />
          </Sider>
          
          <Content className="app-content">
            <div className="content-container">
              {renderContent()}
            </div>
          </Content>
        </Layout>
        
        <Footer className="app-footer">
          <p>© 2024 Фото Камера. Создано с ❤️</p>
        </Footer>
      </Layout>
    </ConfigProvider>
  );
}

export default App;
